import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

    addField(event) {
        var name = event.target.dataset['name']
        var value = event.target.value
        event.target.form.querySelector(`input[type=hidden][name="${name}"]`).setAttribute('value', value)
    }

    // Month clicks submit immediately, and the sidebar keeps this picker on screen
    // across that reload, so the closed label and the highlighted month must move
    // here. The fresh page would paint them, but that paint is discarded.
    selectMonth(event) {
        const button = event.currentTarget
        this.addField({target: button})

        const picker = button.closest('[data-controller~="dropdown"]')
        if (!picker) return

        const label = picker.querySelector('[data-month-label]')
        if (label) label.textContent = button.textContent.trim()

        picker.querySelectorAll('[data-month-choice]').forEach((choice) => {
            const selected = choice === button
            choice.classList.toggle('bg-brand', selected)
            choice.classList.toggle('text-white', selected)
            choice.classList.toggle('text-ink', !selected)
            choice.classList.toggle('hover:bg-surface-subtle', !selected)
            if (selected) choice.setAttribute('aria-current', 'date')
            else choice.removeAttribute('aria-current')
        })
    }

    refresh(event) {
        if (!window.confirm("Are you sure you want to delete the table?")) {
            event.preventDefault()
        }
    }

    checkText(event) {
        const formValid = event.target.form.checkValidity()
        if (formValid) {
            const parent = event.target.form.querySelector("#data-table-container")
            const nameInputs = parent.querySelectorAll("#column-data")
            const nameValues = []
            nameInputs.forEach(input => {
                let nameInput = input.querySelector('input[type="text"]')
                nameValues.push(nameInput.value.toLowerCase().trim())
            })
            if ((new Set(nameValues)).size !== nameValues.length) {
                alert("Names must be unique.")
                event.preventDefault()
            } else {
                event.target.form.submit()
            }
        }
    }

    checkValidation(event) {
        const formValid = event.target.form.checkValidity()
        if (formValid) {
            const parent = event.target.form.querySelector("#data-table-container")
            const nameInputs = parent.querySelectorAll("#column-data")
            const nameValues = []
            const columnNames = event.target.dataset.colNames
            nameInputs.forEach(input => {
                let nameInput = input.querySelector('input[type="text"]')
                nameValues.push(nameInput.value.toLowerCase().trim())
            })
            const concatValues = nameValues.concat(columnNames.split(","))
            if ((new Set(concatValues)).size !== concatValues.length) {
                alert("Names must be unique.")
                event.preventDefault()
            } else {
                event.target.style.opacity = "0.6";
                event.target.style.pointerEvents = "none"
                event.target.value = 'Processing....'
            }
        }
    }

    disable(event) {
        const formValid = event.target.form.checkValidity()
        if (formValid) {
            event.target.style.opacity = "0.6";
            event.target.style.pointerEvents = "none"
            event.target.value = 'Processing....';
        }
    }

    close(event) {
        this.element.innerHTML = ''

    }
}

